export const appCheckMarkIcon = {
    data: `<svg viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3L2.96154 5.25L7 0.75" stroke="#51AD95" stroke-width="0.5"/></svg>`,
    name: 'check-mark'
};